// 실제 매장으로 확인된 공개 정보만 이 파일에 기록합니다.
// 영업시간과 방문 가능 여부는 바뀔 수 있으므로 각 매장의 공식 채널을 함께 제공합니다.
export const shops = [
  {
    id: '93vintage-busan',
    name: '93빈티지 부산본점',
    address: '부산 부산진구 동천로108번길 30 1층',
    region: '전포',
    hours: '13:00 — 20:00 · 방문 전 확인',
    category: '빈티지 의류',
    coordinates: [35.1582404, 129.0640191],
    description: '빈티지와 세컨핸드 의류를 다루는 93빈티지의 부산 본점.',
    cardImage: '/images/93빈티지 본점 1.jpeg',
    images: [
      {
        src: '/images/93빈티지 본점 1.jpeg',
        alt: '93빈티지 부산본점 매장 전경',
      },
      {
        src: '/images/93빈티지 본점2.jpeg',
        alt: '93빈티지 부산본점 입구의 매장 안내 입간판',
      },
    ],
    tags: ['세컨핸드', '의류'],
    sourceLabel: '매장 프로필',
    sourceUrl: 'https://fruitsfamily.com/seller/5d6n/collectormoomoo93',
  },
  {
    id: '93vintage-jeonpo',
    name: '93빈티지 전포사잇길점',
    address: '부산 부산진구 동성로25번길 15 1층',
    region: '전포',
    hours: '영업시간은 공식 채널 확인',
    category: '빈티지 의류',
    coordinates: [35.1526743, 129.0675792],
    description: '전포사잇길에 자리한 93빈티지의 두 번째 부산 매장.',
    tags: ['세컨핸드', '의류'],
    sourceLabel: '매장 프로필',
    sourceUrl: 'https://fruitsfamily.com/seller/5d6n/collectormoomoo93',
  },
  {
    id: 'bonovista-showroom',
    name: '보노비스타 & 보타 쇼룸',
    address: '부산 부산진구 전포대로255번길 43-10 2층',
    region: '전포',
    hours: '쇼룸 운영 일정은 공식 채널 확인',
    category: '빈티지 의류',
    coordinates: [35.1589405, 129.0629064],
    description: '미국·유럽·일본의 중고 및 빈티지 의류와 식물을 함께 소개하는 쇼룸.',
    tags: ['해외 빈티지', '쇼룸'],
    sourceLabel: '공식 사이트',
    sourceUrl: 'https://m.bonovista.com/bonovista.html',
  },
  {
    id: 'orleans-store',
    name: '올리언스 스토어',
    address: '부산 해운대구 우동1로 34 지하 1층',
    region: '해리단길',
    hours: '12:00 — 20:00',
    category: '아메리칸 캐주얼',
    coordinates: [35.1644504, 129.1571427],
    description: '1950–90년대 아메리칸 캐주얼을 바탕으로 빈티지 의류와 액세서리를 선보이는 숍.',
    tags: ['아메리칸', '업사이클'],
    sourceLabel: '공식 사이트',
    sourceUrl: 'https://orleansstore1.imweb.me/about',
  },
  {
    id: 'vintageye',
    name: '빈티지아이 콜렉터스 클럽',
    address: '부산 중구 해관로 79',
    region: '중앙동',
    hours: '10:00 — 19:00 · 방문 예약 권장',
    category: '빈티지 시계',
    coordinates: [35.10597, 129.03531],
    description: '빈티지 시계를 선별하고 감별·복원해 소개하는 콜렉터스 클럽.',
    tags: ['시계', '컬렉터스'],
    sourceLabel: '공식 사이트',
    sourceUrl: 'https://vintageye.kr/about.html',
  },
]

export const regions = [...new Set(shops.map((shop) => shop.region))]
export const categories = [...new Set(shops.map((shop) => shop.category))]
